import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import {keyframes} from '@emotion/core'
import styled from '@emotion/styled'

const keyframesOpacity = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.25;
  }
}`

const DotSpan = styled('span')(({dotNumber}) => ({
  animationDelay: `${dotNumber * 200}ms`,
  animationDuration: '.8s',
  animationIterationCount: 'infinite',
  animationName: keyframesOpacity.toString(),
  display: 'inline-block',
  fontWeight: 600,
  lineHeight: 'inherit',
  verticalAlign: 'baseline'
}))

const GroupStyle = styled('span')({
  display: 'inline',
  fontSize: 'inherit'
})

const Ellipsis = () => {
  return (
    _jsxs(GroupStyle, { children: [
      _jsx(DotSpan, { dotNumber: 0, children: "."})
      , _jsx(DotSpan, { dotNumber: 1, children: "."})
      , _jsx(DotSpan, { dotNumber: 2, children: "."})
    ]})
  )
}

export default Ellipsis
